import template from '../../mad-id.module.scss';
import { IAccordionMad } from '../../mad-id.state';
import AccordionItem from '../../accordion/accordion';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './accordion.module.scss'
interface AccordionSectionProps {
    title: string;
    subtitle: string;
    accordion: Array<IAccordionMad>;
}

const AccordionSection = ({ title, subtitle, accordion }: AccordionSectionProps) => {
    return (
        <section className={`${template.section}`}>
            <div className={`${template.container}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_medium} ${template.margin_bot24px}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${template.text} ${template.text_medium} ${template.margin_bot32px}`}>
                                {subtitle}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${style.accordion}`}>
                    {accordion.map((item: IAccordionMad, index: number) => {
                        return <AccordionItem key={index} id={item.id} title={item.title} text={item.text} />
                    })}
                </div>
            </div>
        </section>
    )
}

export default AccordionSection;
